import { render, staticRenderFns } from "./LayoutWithBackBtn.vue?vue&type=template&id=17f48b52&"
import script from "./LayoutWithBackBtn.vue?vue&type=script&lang=js&"
export * from "./LayoutWithBackBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports